<div class="Container Flexbox Flexbox--column Gap--normal" #Container [class.SlideIn]="shouldAnimateIn" [class.SlideOut]="shouldAnimateOut">
  @for (category of displayableCategories(); track $index) {
      <div class="DesignGroup Grid Gap--smaller">
        <h3 class="DesignGroupTitle">{{ category.name }}</h3>
        @let designsInCategory = getDesignsInCategory(category.id);
        @let firstDesignsInCategory = designsInCategory.slice(0, 6);
        @let remaininDesignsInCategory = designsInCategory.slice(6);
        @for(design of firstDesignsInCategory; track $index) {
          <app-design-card #DesignCard [design]="design" (designClick)="designClick($event)" [isSelected]="selectedDesign()?.id === design.id" [isAvailable]="reachableDesigns().includes(design.id)"></app-design-card>
        }

        @if (category.isExpanded) {
          @for(design of remaininDesignsInCategory; track $index) {
            <app-design-card #DesignCard [design]="design" (designClick)="designClick($event)" [isSelected]="selectedDesign()?.id === design.id" [isAvailable]="reachableDesigns().includes(design.id)"></app-design-card>
          }
        } @else if (selectedDesign()?.categories?.includes(category.id) && !doesContainSelectedDesign(firstDesignsInCategory)) {
          <app-design-card #DesignCard [design]="selectedDesign()" (designClick)="designClick($event)" [isSelected]="selectedDesign()?.id === selectedDesign()!.id" [isAvailable]="reachableDesigns().includes(selectedDesign()!.id)"></app-design-card>
        }

        @let remainingCount = remaininDesignsInCategory.length - (selectedDesign()?.categories?.includes(category.id) && !doesContainSelectedDesign(firstDesignsInCategory) ? 1 : 0);
        @if (remainingCount > 0) {
          <button class="ShowMoreButton ThemeColorAccent" mat-button (click)="toggleCategoryIsExpanded(category)">
            @if (!category.isExpanded) {
              Show {{ remainingCount }} more
            } @else {
              Show less
            }
          </button>
        }
      </div>
    }
</div>
